import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach((item, index) => {
    const el = {
      ...item.user,
      key: item.user.uuid + `_${index}`,
      creator: {
        uuid: item.user.uuid,
        avatar_url: item.user.avatar_url,
        avatar_params: item.user.avatar_params,
        name: item.user.name,
        social_accounts: item.user.social_accounts
      },
      stats: item.stats,
      select: { id: item.user.uuid, value: false },
      operations: {
        ...item.user,
        key: item.user.uuid + `_${index}`
      }
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getRecommendedCreators({ payload: { signal } }) {
  try {

    const { data } = yield call(fetch, {
      api: api.recommended_creators,
      params: {
        page: 1,
        page_size: 8
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getRecommendedCreatorsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getRecommendedCreatorsFailed,
      endpoint: api.recommended_creators.url
    });
  }
}

export const getRecommendedCreatorsSaga = takeEvery(types.GET_RECOMMENDED_CREATORS_REQUEST, getRecommendedCreators);